import { postQuizResult } from '../api'

interface IReturn {
  save: () => void
}

const useSaveUserAnswers = (
  quizId: string,
  userAnswers: IUserAnswer[],
  timer: string
): IReturn => {
  const save = (): void => {
    postQuizResult(quizId, userAnswers, timer)
      .then(res => {
        window.location.replace(res.data)
      })
      .catch((error: unknown) => {
        console.error(error)
      })
  }
  return { save }
}

export default useSaveUserAnswers
